<template>
  <main>
    <div class="container mt-5">
      <div class="row g-5">
        <div class="col-md-5">
          <div class="card border-0 p-5 shadow-custom w-100">
            <div class="chartjs-wrapper">
              <rekap-bencana v-if="rekapBencana.loaded" :data="rekapBencana.data"></rekap-bencana>
            </div>
          </div>
        </div>
        <div class="col-md-7 bg-white p-5 shadow-custom">
          <h1 id="line1" class="fw-bold">Statistik jumlah laporan</h1>
          <p>A line chart is a way of plotting data points on a line. Often, it is used to show trend data, or
            the comparison of two data sets.</p>
          <p>
          <div class="chartjs-wrapper">
            <jml-laporan v-if="jmlLaporan.loaded" :data="jmlLaporan.data"></jml-laporan>
          </div>
        </div>
      </div>
    </div>
    <div class="container mt-4">
      <div class="row">
        <div class="col-md-6 rounded-3">
          <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img src="assets/images/laporan-1.png" class="d-block w-100"
                     style="border-radius: 8px" alt="...">
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row g-3">
            <div class="col-md-6">
              <div class="card border-0 p-3 shadow-custom-1 w-100">
                <div class="card-body">
                  <p class="card-title fw-bold">Call Center</p>
                  <p class="card-text" style="font-size: 12px">Layanan Contact Center.</p>
                  <p class="text-primary fs-5"><i class="lni lni-phone"></i> (022) 4264318</p>

                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card border-0 p-3 shadow-custom-1 w-100">
                <div class="card-body">
                  <p class="card-title fw-bold">Hotline PUSAKA</p>
                  <p class="card-text" style="font-size: 12px">Layanan Contact Center.</p>
                  <p class="text-primary fs-5"><i class="lni lni-phone"></i> (022) 4264318</p>
                </div>
              </div>
            </div>
            <div class="col-md-12 mt-3">
              <div class="card border-0 p-2 shadow-custom-1 w-100">
                <div class="card-body">
                  <h5 class="card-title fw-bold">Sosial Media</h5>
                  <p class="card-text">Jangan ketinggalan informasi terbaru tentang PUSAKA di sosial
                    media dibawah!</p>
                  <a href="#" class="card-link">Instagram</a>
                  <a href="#" class="card-link">Website Resmi</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section class="bonus-section mt-100">
      <div class="container">
        <div class="bg-primary text-white p-5 rounded shadow-custom">
          <h1 class="fw-bold">Lakukan lebih dengan PUSAKA</h1>
          <p class="lead">Tunggu apa lagi? segera laporkan kondisi sekolah anda ke pusat untuk segera di
            pantau
            dan segera ditindak sesuai tindakan yang akan dilakukan</p>
          <a class="text-white" href="/login">Masuk
            &raquo;</a>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import RekapBencana from "@/components/chart/RekapBencana";
import JmlLaporan from "@/components/chart/JmlLaporan";
import repository from "@/repository";

export default {
  name: 'Laporan',
  components: {
    RekapBencana,
    JmlLaporan,
  },
  data() {
    return {
      rekapBencana: {
        loaded: false,
        data: {
          labels: [],
          datasets: []
        }
      },
      jmlLaporan: {
        loaded: false,
        data: {
          labels: [],
          datasets: []
        }
      }
    }
  },
  mounted() {
    this.getRekapBencana()
    this.getJmlLaporan()
  },
  methods: {
    async getRekapBencana() {
      this.loaded = false
      const {data} = await repository.get('/v1/chart/rekap-bencana')
      const labels = data.data.label
      const datasets = data.data.datasets
      this.rekapBencana.data = {
        labels,
        datasets
      }
      this.rekapBencana.loaded = true
    },
    async getJmlLaporan() {
      this.loaded = false
      const {data} = await repository.get('/v1/chart/jml-laporan')
      const labels = data.data.labels
      const datasets = data.data.datasets
      this.jmlLaporan.data = {
        labels,
        datasets
      }
      this.jmlLaporan.loaded = true
    }
  }
}
</script>

<style scoped>

.shadow-custom-1 {
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 4px 0px, rgba(0, 0, 0, 0.1) 0px 4px 24px 0px;
}

.shadow-custom {
  box-shadow: 0 2.9px 0.7px rgba(0, 0, 0, 0),
  0 5.8px 1.5px rgba(0, 0, 0, 0.001),
  0 8.7px 2.5px rgba(0, 0, 0, 0.001),
  0 11.7px 3.7px rgba(0, 0, 0, 0.002),
  0 14.4px 5.4px rgba(0, 0, 0, 0.003),
  0 15.4px 7.6px rgba(0, 0, 0, 0.004),
  0 17.4px 10.8px rgba(0, 0, 0, 0.006),
  0 19.5px 15.7px rgba(0, 0, 0, 0.008),
  0 21.7px 24.2px rgba(0, 0, 0, 0.012),
  0 24px 43px rgba(0, 0, 0, 0.02);
}
</style>
